import React from 'react';

const DisabledRowStyles = () => (
    <style>
        {`
            .disabled-row {
                background-color: #ffebee !important;
                color: #000 !important;
            }
            .disabled-row td {
                background-color: #ffebee !important;
                color: #000 !important;
            }
        `}
    </style>
);

export default DisabledRowStyles;